function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const GreenArrow = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 41 51",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.0722 8.78397C11.8783 33.2122 26.8733 42.7179 34.645 44.4172",
  stroke: "#8AC149",
  strokeWidth: "2.4556"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.98725 14.6964L14.7127 3.91468L26.3092 16.3417",
  stroke: "#8AC149",
  strokeWidth: "2.4556"
}));

GreenArrow.defaultProps = {
  width: 41,
  height: 51
};
export default GreenArrow;